/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TestGoogleDriveConnectionMutationInput = {
    folderId: string;
    clientMutationId?: string | null | undefined;
};
export type GoogleOAuthConfigViewTestConnectionMutationVariables = {
    input: TestGoogleDriveConnectionMutationInput;
};
export type GoogleOAuthConfigViewTestConnectionMutationResponse = {
    readonly testGoogleDriveConnection: {
        readonly valid: boolean;
    } | null;
};
export type GoogleOAuthConfigViewTestConnectionMutation = {
    readonly response: GoogleOAuthConfigViewTestConnectionMutationResponse;
    readonly variables: GoogleOAuthConfigViewTestConnectionMutationVariables;
};



/*
mutation GoogleOAuthConfigViewTestConnectionMutation(
  $input: TestGoogleDriveConnectionMutationInput!
) {
  testGoogleDriveConnection(input: $input) {
    valid
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TestGoogleDriveConnectionMutationPayload",
    "kind": "LinkedField",
    "name": "testGoogleDriveConnection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GoogleOAuthConfigViewTestConnectionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoogleOAuthConfigViewTestConnectionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4c5b3e9d27e48abffb3269f28d60f2b",
    "id": null,
    "metadata": {},
    "name": "GoogleOAuthConfigViewTestConnectionMutation",
    "operationKind": "mutation",
    "text": "mutation GoogleOAuthConfigViewTestConnectionMutation(\n  $input: TestGoogleDriveConnectionMutationInput!\n) {\n  testGoogleDriveConnection(input: $input) {\n    valid\n  }\n}\n"
  }
};
})();
(node as any).hash = '04de514d257926ccb7bff06325367189';
export default node;
